import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChatStateService } from 'src/app/services/chat-state.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-chat-config',
  templateUrl: './chat-config.component.html',
  styleUrls: ['./chat-config.component.scss']
})
export class ChatConfigComponent implements OnInit, OnDestroy {
  currentEnv = environment.deployment;
  sub!: Subscription;
  temperature!: number;
  max_tokens!: number;
  valueChange1: boolean = false;
  valueChange2: boolean = false;
  style_guide: boolean = true;
  isSubmitting: boolean = false;
  config: any = {
    "top_p": 0.85, "temperature": 0.7, "model": "gpt4", "max_tokens": 4000, "chat_style": false, "style_guide": true, "chat_model": 'azure'
  }
  constructor(private chatStateService: ChatStateService) {
    this.chatStateService.chatConfigState.next(this.config);
  }


  ngOnInit(): void {
    this.sub = this.chatStateService.chatConfigDefaultState.subscribe((res: any) => {
      this.config = res;
    })
  }

  submit() {
    if (!this.config['chat_model']) this.config['chat_model'] = 'azure';

    this.isSubmitting = true;
    // this.chatStateService.updateChatConfig.next(this.config);
    if (this.valueChange1 == true) {
      this.config.temperature = Number(this.temperature);
    }
    if (this.valueChange2 == true) {
      this.config.max_tokens = Number(this.max_tokens);
    }
    // this.chatStateService.chatConfigDefaultState.next(this.config);
    this.chatStateService.chatConfigState.next(this.config);

    setTimeout(() => {
      this.isSubmitting = false;
    }, 1000);
  }

  chatModelChange(model: any) {
    if (this.config['chat_model'] != model) {
      this.chatStateService.chatResetState.next({ reset: true })
    }

    this.config['chat_model'] = model;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.valueChange1 = false;
    this.valueChange2 = false;
  }

  handleValueChange(value: number) {
    // console.log(value);
    this.valueChange1 = true;
    this.temperature = value;
    // this.config.temperature = this.temperature.toParseInt();
    // this.chatStateService.updateChatConfig.next(this.config);
  }

  handleValueChange1(value: number) {
    // console.log(value);
    this.valueChange2 = true;
    this.max_tokens = value;
    // this.config.max_tokens = this.max_tokens.toParseInt();
    // this.chatStateService.updateChatConfig.next(this.config);
  }

  handleValueChange3() {
    // console.log(event);
    this.style_guide = !this.style_guide;
    // console.log(this.style_guide);
    this.chatStateService.chatConfigDefaultState.next(this.config);
  }
}

